import { Component } from '@angular/core';
import { getUiStrings, UiStrings } from '../i18n/ui';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.css'],
})
export class PageNotFoundComponent {
    copy: UiStrings = getUiStrings();
}
